import React from 'react'
import {
  PlayerContextProvider,
  PlayerContextConsumer
} from '@cassette/core'
import MediaProgress from './AudioProgress'
import PlayPauseButton from './AudioButton'
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';

class CorePlayer extends React.PureComponent {
  render() {
    if (!this.props.source) {
      return ''
    }
    const { source, contentType, tempduration, supportedMediaSessionActions, filename, showDelete, handleDelete, ...other } = this.props
    const playlist = [{
      sources: [{
        src: source,
        type: contentType || "audio/wav"
      }],
      title: "",
    }]

    return (
        <PlayerContextProvider
          playlist={playlist}
          supportedMediaSessionActions={['play','pause']}
          defaultRepeatStrategy="none"
          {...other}
        >
          <PlayerContextConsumer >
            {
              playerContext => (

                <Grid container direction="column" justify="flex-start" alignItems="flex-start" spacing={24}>
                  <Grid item xs={12}>
                    <PlayPauseButton />
                  </Grid>
                  <Grid item xs={12}>
                    <MediaProgress tempduration={tempduration} />
                  </Grid>
                   
                  {
                    
                    filename && (
                        <div className="d-flex align-items-center" style={{paddingLeft:'12px'}}> 
                          <div className="playerTime">File: {filename}</div>
                        {
                          showDelete && (
                            <div  style={{cursor: 'pointer'}}>
                              <Icon onClick={handleDelete}>delete_forever</Icon>
                            </div>
                          )
                        }
                     </div>
                    )
                    
                  }
                 
                </Grid>
              )
            }
          </PlayerContextConsumer>

        </PlayerContextProvider>
    )
  }
}

export default CorePlayer



// WEBPACK FOOTER //
// ./src/js/components/Mui/AudioPlayer.js